<template>
    <layout-card
        :error="error"
        :isCustomizable="settings.isCustomizable"
        @hide-card="$emit('hide-card', 'task')"
        @refresh-card="fetchCard('task', {}, true)"
        class="card-task"
        :loading="loading"
        @edit-card="toggleSettingsForm"
    >
        <!-- SLOTED TITLE -->
        <template slot="title">
            {{ name }}
        </template>

        <!-- SLOTED ACTIONS -->
        <template slot="actions">
            <CompassIconButton icon="plus" @click="onCreateTask" />
        </template>

        <!-- SLOTED CONTENT -->
        <template slot="content" v-if="cardData && Object.keys(cardData).length > 0">
            <el-tabs value="current" class="flex-column wp-10 hp-10 task-tab">
                <el-tab-pane name="late" class="flex-column hp-10 pr-2">
                    <span slot="label">
                        <span class="semibold">{{ $l10n.__('En retard') }}</span>
                        <el-badge :value="countTasks(lateTasks)"></el-badge>
                    </span>
                    <div v-if="lateTasks.length > 0" class="aright mb-2">
                        <a :href="cardData.late.link" class="link aright">{{
                            $l10n.__('Voir toutes les tâches en retard')
                        }}</a>
                    </div>
                    <template v-if="lateTasks.length > 0">
                        <ul class="task-list">
                            <li
                                v-for="task in lateTasks"
                                :key="task.id"
                                @click="taskDetail(task)"
                                class="mb-1 br"
                            >
                                <task :task="task" type="late" />
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                        <div
                            class="my-0 mx-auto flex-column hp-10 ai-center jc-center"
                            style="width: 170px"
                        >
                            <img
                                src="/ressources/logged/img/dashboard/dashboard-task.svg"
                                alt=""
                                width="120"
                            />
                            <div class="mt-3 gray-60 acenter">
                                {{ $l10n.__("Vous n'avez aucune tâche en retard") }}
                            </div>
                        </div>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="current" class="flex-column hp-10 pr-2">
                    <span slot="label">
                        <span class="semibold">{{ $l10n.__('À faire') }}</span>
                        <el-badge :value="countTasks(currentTasks)"></el-badge>
                    </span>
                    <div v-if="currentTasks.length > 0" class="aright mb-2">
                        <a :href="cardData.current.link" class="link aright">{{
                            $l10n.__('Voir toutes les tâches à faire')
                        }}</a>
                    </div>
                    <template v-if="currentTasks.length > 0">
                        <ul class="task-list">
                            <li
                                v-for="task in currentTasks"
                                :key="task.id"
                                @click="taskDetail(task)"
                                class="mb-1 br"
                            >
                                <task :task="task" type="current" />
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                        <div
                            class="my-0 mx-auto flex-column hp-10 ai-center jc-center"
                            style="width: 170px"
                        >
                            <img
                                src="/ressources/logged/img/dashboard/dashboard-task.svg"
                                alt=""
                                width="120"
                            />
                            <div class="mt-3 gray-60 acenter">
                                {{ $l10n.__("Vous n'avez aucune tâche à faire") }}
                            </div>
                        </div>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="incoming" class="flex-column hp-10 pr-2">
                    <span slot="label">
                        <span class="semibold">{{ $l10n.__('À venir') }}</span>
                        <el-badge :value="countTasks(incomingTasks)"></el-badge>
                    </span>
                    <div v-if="incomingTasks.length > 0" class="aright mb-2">
                        <a :href="cardData.incoming.link" class="link aright">{{
                            $l10n.__('Voir toutes les tâches à venir')
                        }}</a>
                    </div>
                    <template v-if="incomingTasks.length > 0">
                        <ul class="task-list">
                            <li
                                v-for="task in incomingTasks"
                                :key="task.id"
                                @click="taskDetail(task)"
                                class="mb-1 br"
                            >
                                <task :task="task" type="incoming" />
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                        <div
                            class="my-0 mx-auto flex-column hp-10 ai-center jc-center"
                            style="width: 170px"
                        >
                            <img
                                src="/ressources/logged/img/dashboard/dashboard-task.svg"
                                alt=""
                                width="120"
                            />
                            <div class="mt-3 gray-60 acenter">
                                {{ $l10n.__("Vous n'avez aucune tâche à venir") }}
                            </div>
                        </div>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="completed" class="flex-column hp-10 pr-2">
                    <span slot="label">
                        <span class="semibold">{{ $l10n.__('Terminées') }}</span>
                        <el-badge :value="countTasks(completedTasks)"></el-badge>
                    </span>
                    <div v-if="completedTasks.length > 0" class="aright mb-2">
                        <a :href="cardData.completed.link" class="link aright">{{
                            $l10n.__('Voir toutes les tâches terminées')
                        }}</a>
                    </div>
                    <template v-if="completedTasks.length > 0">
                        <ul class="task-list">
                            <li
                                v-for="task in completedTasks"
                                :key="task.id"
                                @click="taskDetail(task)"
                                class="mb-1 br"
                            >
                                <task :task="task" type="completed" />
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                        <div
                            class="my-0 mx-auto flex-column hp-10 ai-center jc-center"
                            style="width: 170px"
                        >
                            <img
                                src="/ressources/logged/img/dashboard/dashboard-task.svg"
                                alt=""
                                width="120"
                            />
                            <div class="mt-3 gray-60 acenter">
                                {{ $l10n.__("Vous n'avez aucune tâche terminée") }}
                            </div>
                        </div>
                    </template>
                </el-tab-pane>
            </el-tabs>
            <portal to="dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </portal>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import Task from './Task.vue';
import CardMixin from './CardMixin.js';
import Feature from 'Services/Feature';

export default {
    mixins: [CardMixin],
    created() {
        window.EventBus.$on('refresh_task', () => {
            this.fetchCard(this.type);
        });

        window.EventBus.$on('toggle_task', (payload) => {
            this.toggleTask(payload);
        });
    },
    data() {
        return {
            App: App,
            settingsFormName: 'task-setting-form',
        };
    },
    computed: {
        lateTasks() {
            let late = [];
            for (var task in this.cardData.late.items) {
                late.push(this.cardData.late.items[task]);
            }
            return late.sort(function (a, b) {
                return b.timestampStart - a.timestampStart;
            });
        },
        currentTasks() {
            let current = [];
            for (var task in this.cardData.current.items) {
                current.push(this.cardData.current.items[task]);
            }
            return current.sort(function (a, b) {
                return a.timestampStart - b.timestampStart;
            });
        },
        incomingTasks() {
            let incoming = [];
            for (var task in this.cardData.incoming.items) {
                incoming.push(this.cardData.incoming.items[task]);
            }
            return incoming.sort(function (a, b) {
                return a.timestampStart - b.timestampStart;
            });
        },
        completedTasks() {
            let completed = [];
            for (var task in this.cardData.completed.items) {
                completed.push(this.cardData.completed.items[task]);
            }
            return completed.sort(function (a, b) {
                return a.timestampStart - b.timestampStart;
            });
        },
    },
    methods: {
        onCreateTask() {
            Activities.openActivityForm(
                null,
                null,
                null,
                () => EventBus.$emit('refresh_task'),
                'task',
            );
        },
        taskDetail(task) {
            if (
                Feature.isEnabled('activity-new-creation-panel') &&
                !['delivery', 'proforma'].includes(task.relatedtype)
            ) {
                Activities.openNewActivityDetail(
                    task.id,
                    task.relatedid,
                    task.relatedtype,
                    task.relatedSubType ?? null,
                    'task',
                    () => EventBus.$emit('refresh_task'),
                    () => EventBus.$emit('refresh_task'),
                    () => EventBus.$emit('refresh_task'),
                );
            } else {
                task.edit = task.edit === 'N' && task.user != task.owner ? 'N' : 'Y';
                Agenda.cardForm(
                    task.id,
                    0,
                    'task',
                    task.edit,
                    true,
                    task.start,
                    task.end,
                    'N',
                    task.relatedtype,
                );
            }
        },
        countTasks(tasks) {
            var total = Object.keys(tasks).length;
            return total >= 50 ? '49+' : total;
        },
        toggleTask(payload) {
            let card = this.cardData[payload.source].items[payload.id];
            card.status = payload.status;

            if (
                Array.isArray(this.cardData[payload.target].items) &&
                this.cardData[payload.target].items.length == 0
            ) {
                this.cardData[payload.target].items = {};
            }
            Vue.set(this.cardData[payload.target].items, payload.id, card);
            Vue.delete(this.cardData[payload.source].items, payload.id);
        },
    },
    components: {
        LayoutCard,
        Task,
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';
.card-task {
    header a {
        font-weight: $font-weight-regular;
    }
    .el-badge sup {
        font-size: $very-small-font-size;
        top: -0.1em;
        background-color: $gray-60;
    }
    .is-active {
        .el-badge sup {
            background-color: $primary;
        }
    }
    .task-tab .el-tabs__content {
        height: 100%;
    }
    .task-list {
        li {
            > div {
                display: flex;
                align-items: center;
                padding: spacer(2);
                @include border-radius();

                button.toggle-task {
                    margin-right: 16px;
                    flex-shrink: 0;
                }
            }

            &:hover {
                background-color: $primary-05;
                cursor: pointer;
            }

            &.task-late {
                background-color: $alert-05;

                &:hover {
                    background-color: $alert-50;
                }
            }
        }
    }
}
</style>
